import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ErrorBox,
  useToast,
} from "@gearbox-protocol/deploy-tools-ui";
import { api } from "api";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useAsyncFn } from "react-use";

interface DeleteDialogProps {
  definitionId: string;
  open?: boolean;
  onOpen?: (open: boolean) => void;
}

const DeleteDialog: FC<DeleteDialogProps> = props => {
  const { definitionId, open, onOpen } = props;
  const navigate = useNavigate();
  const { toast } = useToast();

  const [{ loading, error }, submit] = useAsyncFn(async () => {
    try {
      await api.deleteTaskDefinition(definitionId);
      toast({
        title: "Deleted",
        description: `Task definition ${definitionId} deleted`,
      });
      await navigate("/task-definitions");
    } catch (e) {
      toast({
        variant: "destructive",
        title: "Error",
        description: `${e}`,
      });
    }
  }, [definitionId, navigate]);

  return (
    <Dialog modal open={open} onOpenChange={onOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete task definition</DialogTitle>
          <DialogDescription>Please confirm deletion</DialogDescription>
        </DialogHeader>

        {!!error && <ErrorBox error={error} />}

        <DialogFooter>
          <Button
            type="submit"
            variant="destructive"
            disabled={loading}
            loading={loading}
            onClick={submit}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteDialog;
